import { useQuery } from 'react-query';

import { applianceQueryKeys } from '../QueryKeys';
import useApiHelper from '../../hooks/useApiHelper';
import { IAppliance } from '../../types/Appliance/Appliance';
import { IDefaultResponseWithData } from '../../types/system/DefaultResponse';

export default function useAppliances() {
  const { get } = useApiHelper();

  const appliances = useQuery({
    queryKey: applianceQueryKeys.all(),
    queryFn: () =>
      get<IDefaultResponseWithData<IAppliance>>('/v1/appliance').then(
        (res) => res.data.data
      ),
  });

  return {
    appliances,
  };
}
